export default __webpack_public_path__ + "static/media/logo-jinpeng.eaaff0ef.png";